module.exports = __webpack_public_path__ + "assets/img/OverExchange_btn.3fa7abff.png";